/**
 * abilityVfxMoltenShield — Annie E Molten Shield fiery bubble aura (SP-15).
 */
export function buildMoltenShield(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.55 * (spec.scale || 1.35);
  const orange = mat(THREE, spec.color || 0xf97316, 0.55);
  const gold = mat(THREE, 0xfbbf24, 0.75);
  const red = mat(THREE, 0xdc2626, 0.65);
  addBubbleDome(THREE, group, s, orange, gold);
  addRippleRings(THREE, group, s, orange, gold);
  addFlameWisps(THREE, group, s, red, gold);
  group.userData = { shape: 'molten_shield' };
  return group;
}

function addBubbleDome(THREE, group, s, orange, gold) {
  const dome = new THREE.Mesh(new THREE.SphereGeometry(s, 14, 12), orange);
  dome.position.y = 0.45 * s;
  group.add(dome);
  const core = new THREE.Mesh(new THREE.SphereGeometry(s * 0.32, 10, 10), gold);
  core.position.y = 0.5 * s;
  group.add(core);
}

function addRippleRings(THREE, group, s, orange, gold) {
  const inner = new THREE.Mesh(
    new THREE.RingGeometry(s * 0.35, s * 0.65, 22).rotateX(-Math.PI / 2),
    gold
  );
  inner.position.y = 0.05;
  group.add(inner);
  const outer = new THREE.Mesh(
    new THREE.RingGeometry(s * 0.7, s * 1.1, 24).rotateX(-Math.PI / 2),
    orange
  );
  outer.position.y = 0.04;
  group.add(outer);
}

function addFlameWisps(THREE, group, s, red, gold) {
  for (let i = 0; i < 6; i += 1) {
    const a = (Math.PI * 2 / 6) * i;
    const wisp = new THREE.Mesh(new THREE.ConeGeometry(0.08 * s, 0.4 * s, 5), red);
    wisp.position.set(Math.cos(a) * s * 0.75, 0.35 * s, Math.sin(a) * s * 0.75);
    group.add(wisp);
    const spark = new THREE.Mesh(new THREE.SphereGeometry(0.06 * s, 8, 8), gold);
    spark.position.set(Math.cos(a) * s * 0.55, 0.55 * s, Math.sin(a) * s * 0.55);
    group.add(spark);
  }
}

function mat(THREE, color, opacity) {
  return new THREE.MeshBasicMaterial({
    color,
    transparent: true,
    opacity,
    side: THREE.DoubleSide
  });
}
